import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Defineyeppy = () => {
  return (
    <div className="defineyeppy p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>Define Phase</h2>
          </Col>
        </Row>

        <Row className="padd_top">
          <Col xs={12} md={4} lg={3} xl={3} xxl={3}>
            <div className="define_img">
              <StaticImage
                src="../../../images/case-studies/yeppy/def_mob_img.png"
                alt="TekRevol"
                className="img-fluid"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={350}
              />
            </div>
          </Col>
          <Col xs={12} md={8} lg={6} xl={6} xxl={6}>
            <div className="define_img1">
              <StaticImage
                src="../../../images/case-studies/yeppy/def_box_img.png"
                alt="TekRevol"
                className="img-fluid"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={607}
              />
            </div>
            <div className="define_main">
              <div className="define_box_yeppy">
                <div className="define_box_img">
                  <StaticImage
                    src="../../../images/case-studies/yeppy/def_man_img.png"
                    alt="TekRevol"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["png"]}
                    width={399}
                  />
                </div>
                <div className="define_box_content">
                  <ul>
                    <li>Idea Generation</li>
                  </ul>
                  <p>
                    We brainstormed potential solutions, considering both app
                    features and service offerings. Then we ideated on features
                    related to online grocery shopping, delivery, discounts, and
                    secure payment methods.
                  </p>
                </div>
              </div>
              <div className="define_box_yeppy_1">
                <ul>
                  <li>User Journey Mapping</li>
                </ul>
                <div className="define_box_content_1">
                  <p>
                    We mapped out Aisha's typical journey when shopping for
                    groceries, highlighting pain points and opportunities for
                    improvement. Then we identified key touchpoints where the
                    app can intervene to enhance her experience.
                  </p>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
            <div className="define_img2">
              <StaticImage
                src="../../../images/case-studies/yeppy/def_hot_grills.png"
                alt="TekRevol"
                className="img-fluid"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={359}
              />
            </div>
            <div className="define_box_yeppy_2">
              <ul>
                <li>Prioritization</li>
              </ul>
              <div className="define_box_content_2">
                <p>
                  We prioritized ideas based on feasibility, desirability, and
                  alignment with Aisha's goals. Then we selected the most
                  impactful features to include in the Super App{" "}
                  <span>“Yeppy”</span>.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Defineyeppy;
